import { ReactNode, createContext, useState } from 'react'


const SearchContext = createContext({});

export const SearchProvider = ({ children }: { children: ReactNode }) => {
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const value = { isSearchFocused, setIsSearchFocused, showMobileSearch, setShowMobileSearch, searchValue, setSearchValue };

    return (
        <SearchContext.Provider value={value}>
            {children}
        </SearchContext.Provider>
    )
}

export default SearchContext